import { z } from "zod";

import { personalizationSeveritySchema } from "@/types/backoffice/dto/personalization/personalization-severity-dto.ts";
import { personalizationSupportTypeSchema } from "@/types/backoffice/dto/personalization/personalization-support-type-dto.ts";

export const personalizationHistoryStepCsLinkDtoSchema = z.object({
  csLinkId: z.number(),
  interfaceName: z.string().nullable(),
  localisation: z.string().nullable(),
  modulatorSerialNumber: z.string().nullable(),
  refModulationActivationId: z.number(),
});

export const personalizationHistoryStepDtoSchema = z.object({
  applicationDatetime: z.string().pipe(z.coerce.date()).nullable(),
  deletionDatetime: z.string().pipe(z.coerce.date()).nullable(),
  startDatetime: z.string().pipe(z.coerce.date()).nullable(),
  csLinks: z.array(personalizationHistoryStepCsLinkDtoSchema),
});

export const personalizationHistoryDtoSchema = z.object({
  allSite: z.boolean(),
  comment: z.string().nullable(),
  creationDatetime: z.string().pipe(z.coerce.date()),
  creatorCompany: z.string(),
  creatorFirstname: z.string(),
  creatorLastname: z.string(),
  deletionDatetime: z.string().pipe(z.coerce.date()).nullable(),
  id: z.number(),
  steps: z.array(personalizationHistoryStepDtoSchema),
  supportSeverity: z.object({
    label: personalizationSeveritySchema,
  }),
  supportType: personalizationSupportTypeSchema,
});

export type TPersonalizationHistoryStepCsLinkDtoSchema = z.infer<typeof personalizationHistoryStepCsLinkDtoSchema>;
export type TPersonalizationHistoryStepDtoSchema = z.infer<typeof personalizationHistoryStepDtoSchema>;
export type TPersonalizationHistoryDtoSchema = z.infer<typeof personalizationHistoryDtoSchema>;
